"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var common_1 = require("./common");
function populateNextSlides(state, props, slidesHavePassed) {
  void 0 === slidesHavePassed && (slidesHavePassed = 0);
  var nextSlides,
    nextPosition,
    slidesToShow = state.slidesToShow,
    currentSlide = state.currentSlide,
    itemWidth = state.itemWidth,
    totalItems = state.totalItems,
    slidesToSlide = common_1.getSlidesToSlide(state, props),
    nextMaximumSlides = currentSlide + 1 + slidesHavePassed + slidesToShow + (0 < slidesHavePassed ? 0 : slidesToSlide);
  return nextPosition = nextMaximumSlides <= totalItems ? -itemWidth * (nextSlides = currentSlide + slidesHavePassed + (0 < slidesHavePassed ? 0 : slidesToSlide)) : totalItems < nextMaximumSlides && currentSlide !== totalItems - slidesToShow ? -itemWidth * (nextSlides = totalItems - slidesToShow) : nextSlides = void 0, {
    nextSlides: nextSlides,
    nextPosition: nextPosition
  };
}
exports.populateNextSlides = populateNextSlides;